import React, { useEffect } from "react";
import Header from "./Header";
import { trackEvent } from "../utils/trackEvent";
import "./LoanSanctioned.css";
import SupportIcon from "../assets/images/SupportIcon.svg";
import QualityTreatment from "../assets/images/QualityTreatment.svg";
import loanSanctioned from "../assets/images/loanSanctioned.svg";
import sanctionedImg from "../assets/images/sanctionedImg.svg";

const LoanSanctioned = () => {
  // Pull dynamic values if available
  const customerName = localStorage.getItem("name") || "Customer";
  const phoneNumber = localStorage.getItem("phoneNumber") || "";

  useEffect(() => { trackEvent("loan_sanctioned_viewed"); }, []);

  return (
    <div className="loan-container">
      <Header showBackButton={false} />

      <div className="main-content">
        {/* Hero success card */}
        <div className="hero-section hero-success">
          <div className="hero-success-left">
            <h1 className="hero-title">Hey {customerName}</h1>
            <p className="hero-subtitle">
              Your loan is successfully sanctioned
            </p>
          </div>
          <div className="hero-icon hero-success-icon">
            <img src={loanSanctioned} alt="loanSanctioned" />
          </div>
        </div>

        {/* Concierge info card */}
        <div className="concierge-card">
          <p className="concierge-intro">
            Our Concierge Team will call you at
            {phoneNumber && (
              <span className="concierge-intro-number"> {phoneNumber}</span>
            )}
          </p>

          <div className="concierge-point">
            <div className="point-icon">
            <img src={QualityTreatment} alt="Quality Treatment" />
            </div>
            <div className="point-text">To help with hospital admission</div>
          </div>

          <div className="concierge-point">
            <div className="point-icon">
              <img src={SupportIcon} alt="Support" />
            </div>
            <div className="point-text">Support your treatment journey</div>
          </div>
        </div>

        {/* Illustration */}
        <div className="illustration-section bottom-illustration">
          <img src={sanctionedImg} alt="loanSanctioned" />
        </div>
      </div>
    </div>
  );
};

export default LoanSanctioned;
